// Slow, continuous editorial marquee
export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden mask-fade-x ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee gap-10 will-change-transform">
        {doubled.map((t, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-3xl md:text-5xl text-navy/80 italic tracking-tight">
              {t}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-teal shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
